<template>
  <div v-if="showReply">
    <v-card outlined>
      <v-card-text>
        <v-form ref="chatForm" v-model="chatValid">
          <v-row>
            <v-col cols="12">
              <!-- <v-card color="" outlined class="pa-3" v-if="replyAlert && selectedToReply && selectedToReply.body">
                <v-card-text> -->
                  <v-alert
                  v-model="replyAlert"
                  dismissible
                  border="right"
                  color='light-blue lighten-5' 
                ><v-card-text>
                <v-row>
                <small> {{ selectedToReply && selectedToReply.createdTimeUtc | moment }}</small>

                </v-row>
                <v-row>
                  {{
                     selectedToReply && selectedToReply.body.length > 100
                    ? selectedToReply.body.slice(0, 1000) + '...'
                    : selectedToReply ? selectedToReply.body : ''
                  }}
                  
                </v-row>
                 </v-card-text>
                </v-alert>
                <!-- </v-card-text>
                 <span>{{
                  selectedToReply.body.length > 100
                    ? selectedToReply.body.slice(0, 1000) + '...'
                    : selectedToReply.body
                }}</span> 
              </v-card> -->
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="متن پیام"
                outlined 
                auto-grow
                autofocus
                dense
                rows="1"
                required
                :rules="[
                  (v) => {
                    if (v && (v.length > 4096 || v.length < 1)) {
                      return 'تعداد کاراکتر ها باید بین 1 تا 4096 عدد باشد';
                    } else return true;
                  },
                ]"
                v-model="chat.body"
              ></v-textarea>
            </v-col>
            <v-row class="mx-5">
              <v-btn icon small @click="sendMessage()">
                <v-icon> mdi-send </v-icon>
              </v-btn>
              <v-btn icon small @click="closeForm()">
                <v-icon> mdi-close </v-icon>
              </v-btn>
              <FileUpload
                class="mb-4 mt-n2"
                :files="attachments"
                ref="filesUploder"
              ></FileUpload>
            </v-row>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FileUpload from './FileUpload.vue';
import { uuid } from 'vue-uuid';
import Helper from '@/core/helpers';
const conversationRepository = () => RepoFactory.get('conversation');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  props: {
    showReply: {
      type: Boolean,
      default: false,
    },
    selectedToReply: {
      type: Object,
      default: null,
    },
    conversationId: {
      type: String,
      default: null,
    },
    type: {
      type: String,
    },
    topic: {
      type: String,
    },
    objectId: {
      type: String,
    },
    recipientMerchantId: {
      type: String,
    },
    recipientUserId: {
      type: String,
    },
    createdByMerchantId:{
      type: String,
    }
  },
  components: {
    FileUpload,
  },
  data() {
    return {
      replyAlert:true,
      chatValid: true,
      chat: {
        body: null,
        attachments: [],
      },
      attachments: [],
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
  },
  created() {},
  watch: {
    replyAlert(after, before){
      if(!after && before){
        this.$emit('setSelectedToReply', null)
        // selectedToReply = null
      }
    },
    selectedToReply(after, before){
      if(!before && after){
        this.replyAlert = true
      }
    }
  },
  methods: {
    closeForm() {
      // this.chat.body = '';
      this.$refs.chatForm.reset()
      this.chat.attachments = [];
      this.attachments = [];
      this.$emit('closeReplyForm');
    },
    sendMessage() {
      if (this.$refs.chatForm.validate() && this.chat.body && this.chat.body.length) {
        if (
          this.$refs.filesUploder.uploadedFilesId &&
          this.$refs.filesUploder.uploadedFilesId.length
        ) {
          this.chat.attachments = [this.$refs.filesUploder.uploadedFilesId[0]];
        }
        this.sendReply();
      } else {
        this.$dialog.error({
          text: 'وارد کردن متن پیام الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    sendReply() {
      const loader = this.$loading.show();
      this.chat.conversationId = this.selectedToReply && this.selectedToReply.conversationId ?this.selectedToReply.conversationId : this.conversationId;
      this.chat.objectId = this.objectId
      this.chat.createdByMerchantId = this.createdByMerchantId;
      this.chat.recipientUserId = this.recipientUserId;
      this.chat.recipientMerchantId = this.recipientMerchantId;
      this.chat.type = this.type;
      this.chat.topic = this.topic;
      this.chat.parentId = this.selectedToReply && this.selectedToReply.id ?this.selectedToReply.id : null ;
      conversationRepository()
        .addConversation(this.chat, this.baseUrl, {
          MerchantId: this.$store.getters.currentMerchant,
        })
        .then((res) => {
          // this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          // this.$emit('getConversaion');
          conversationRepository()
            .getConversationById(
              this.chat.conversationId,
              this.baseUrl,
              {},
              { threadId: res.data.id }
            )
            .then((res) => {
              let newThread = {
                attachments: res.data.attachments,
                id: res.data.id,
                conversationId: this.chat.conversationId,
                body: this.chat.body,
                status: 'Sent',
                parentId: this.selectedToReply && this.selectedToReply.id ?this.selectedToReply.id :null ,
                parentBody: this.selectedToReply && this.selectedToReply.body ? this.selectedToReply.body : null,
                isMainThread: false,
                isMine: true,
              };
              // this.attachments =[]
              this.$emit('addNewThread', newThread);
              this.closeForm();
            })
            .catch((err) => {
              Helper.handleErrors(err, this);
            });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
